import { useEffect } from "react";
import { useLocation } from "react-router-dom";

const ScrollToTopProductPage = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    if (pathname.startsWith("/portfolio/")) {
      window.scrollTo(0, 0);
    }
  }, [pathname]);

  return null;
};

export default ScrollToTopProductPage;
